function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  rx: 1,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.83179 3.81175C6.83179 4.09897 6.59896 4.33181 6.31175 4.33181C6.0245 4.33181 5.79167 4.09897 5.79167 3.81175C5.79167 3.52452 6.0245 3.29168 6.31175 3.29168C6.59896 3.29168 6.83179 3.52452 6.83179 3.81175ZM1.83333 3.18751C1.83333 2.43962 2.43961 1.83334 3.1875 1.83334H6.9375C7.68537 1.83334 8.29167 2.43962 8.29167 3.18751V6.93751C8.29167 7.68539 7.68537 8.29168 6.9375 8.29168H3.1875C2.43961 8.29168 1.83333 7.68539 1.83333 6.93751V3.18751ZM3.1875 2.45834C2.78479 2.45834 2.45833 2.7848 2.45833 3.18751V6.93751C2.45833 7.03376 2.47697 7.12564 2.51084 7.20972L4.42188 5.42201C4.7823 5.08485 5.34238 5.08485 5.70279 5.42201L7.61408 7.20993C7.648 7.12576 7.66667 7.03384 7.66667 6.93751V3.18751C7.66667 2.7848 7.34021 2.45834 6.9375 2.45834H3.1875ZM7.15287 7.63434L5.27583 5.87843C5.15569 5.76605 4.96899 5.76605 4.84885 5.87843L2.97188 7.63426C3.04003 7.65534 3.11244 7.66668 3.1875 7.66668H6.9375C7.01246 7.66668 7.08479 7.65534 7.15287 7.63434ZM3.70792 8.81251V8.70834H7.04167C7.075 8.70834 7.10808 8.70739 7.14092 8.70543C8.01538 8.65426 8.70871 7.92893 8.70871 7.04164V3.70834H8.81208C9.55996 3.70834 10.1663 4.31462 10.1663 5.06251V7.97918C10.1663 9.1873 9.18688 10.1667 7.97875 10.1667H5.06209C4.31421 10.1667 3.70792 9.56038 3.70792 8.81251Z",
  fill: "#212121"
});

var SvgNativeImages = function SvgNativeImages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNativeImages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/native-images.cf07314a.svg";
export { ForwardRef as ReactComponent };